import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { fromJS } from 'immutable';
import renderEnvComponent from 'data/common/renderEnvComponent';
import UserCard from '../UserCard';

class Step2 extends PureComponent {
    render() {
        const { userForm, handleUser } = this.props;
        return (
            <Grid container spacing={3} justify="center" alignItems="center">
                <Grid container item md={12} lg={6} xl={4}>
                    <UserCard user={fromJS(userForm)} readyToEdit noCancel modeAdd addUserFunc={handleUser} setIsMaster />
                </Grid>
            </Grid>
        );
    }
}

Step2.propTypes = {
    userForm: PropTypes.object.isRequired,
    handleUser: PropTypes.func.isRequired
};
export default withRouter(renderEnvComponent('scenes/Home/components/stepper/Step2', Step2));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/stepper/Step2.js